export default {
  leversSelection: {
    heading: {
      main: "Voici les leviers pour agir sur votre",
      sub: "Transmission",
    },
    more: {
      title: "En savoir plus",
      comment: "En matière de transmission, les pistes de réflexions examinées ici seront privilégiées en fonction des objectifs poursuivis. A titre d'exemple, lorsque la volonté est de réduire les droits de succession, la donation en nue-propriété de biens aux enfants resterait la meilleure solution.",
    },
    tabs: {
      all: "Tout afficher",
      longTerm: "Anticipation de la transmission",
      shortTerm: "Les actions à court terme",
    }
  },
  coupleProtection: {
    title: 'Améliorer la protection au sein du couple',
    description: 'Le statut marital et les aménagements associés sont déterminants en cas de décès d\'un des membres du couple. Ils vont définir les droits et la part auxquels le survivant pourra prétendre sur le patrimoine du défunt.'
  },
  barePropertyDonation: {
    title: 'Mesurer l\'impact des donations en nue-propriété',
    description: 'La donation en nue-propriété permet de transmettre des biens sur une valeur réduite en fonction de l\'âge du donateur, dans la mesure où celui-ci conserve l\'usufruit, à savoir la jouissance des biens ou ses revenus.'
  },
  exoneratedDonation: {
    title: 'Mesurer l\'impact des dons de somme d\'argent exonérés',
    description: 'Les dons de somme d\'argent exonérée permettent de transmettre de son vivant jusqu\'à 31 865 € sans fiscalité tous les 15 ans, sous réserve de respecter des conditions d\'âge pour le donateur et le donataire.'
  },
  lifeAssurance: {
    title: 'Comprendre l\'intérêt de l\'assurance vie sur votre transmission',
    description: 'L\'assurance-vie est une technique de transmission d\'une partie du patrimoine. Au décès du souscripteur-assuré, le capital versé aux bénéficiaires désignés ne fait pas partie de sa succession et bénéficie d\'une fiscalité attractive.'
  },
  portfolioRestructurer: {
    title: 'Augmenter le poids de l\'assurance vie dans votre patrimoine',
    description: 'Mobiliser une partie de votre épargne disponible pour augmenter le poids de l\'assurance-vie dans votre patrimoine et bénéficier des avantages juridiques et fiscaux associés'
  },
  beneficiaryClause: {
    title: 'Modifier les clauses bénéficiaires de vos contrats d\'assurance-vie',
    description: 'Dans un contrat d\'assurance-vie, la clause bénéficiaire permet de définir la ou les personnes qui vont percevoir les fonds au décès du souscripteur. Le contenu de la clause a un impact direct sur la répartition et le coût global de la transmission. Il est conseillé de revoir les clauses de ses contrats tous les 5 ans.'
  },
  protectionSubscription: {
    title: 'Couvrir les coûts de la transmission avec la prévoyance',
    description: 'Un contrat de prévoyance en cas de décès offre aux bénéficiaires désignés un capital hors succession leur permettant de financer notamment le coût de la transmission et les implications de votre décès.'
  },
  funeralCosts: {
    title: 'Couvrir le coût de vos obsèques',
    description: 'Détenir une assurance obsèques permet le versement d\'un capital garanti dédié au règlement des frais d\'obsèques et en option des services d\'assistance à vos proches pour leur organisation. A titre d\'illustration, le coût moyen pour organiser des obsèques s\'élevait en France en 2020 à 4 300 € pour une inhumation et à 3 800 € pour une crémation.'
  }
}
